<template>
  <div>
    <!-- :before-close="handleClose" -->
    <el-drawer
      :title="title"
      :visible.sync="drawer"
      size="80%"
      :wrapperClosable="false"
    >
      <div class="form-center" v-loading="loading">
        <el-form :model="form" ref="form" label-width="100px">
          <el-row>
            <el-col :span="12">
              <el-form-item label="表名称" prop="TableName">
                <el-input
                  v-model="form.TableName"
                  placeholder="表名称"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="表Key" prop="TableKey">
                <el-input
                  v-model="form.TableKey"
                  placeholder="表Key"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="表说明" prop="Describe">
                <el-input
                  v-model="form.Describe"
                  placeholder="表说明"
                  type="textarea"
                  rows="3"
                  resize="none"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <el-table
          :data="form.list"
          ref="table"
          style="width: 100%"
          height="calc(100% - 120px)"
        >
          <el-table-column label="序号" width="50" type="index">
          </el-table-column>

          <el-table-column label="字段名称" align="center" prop="FieldName">
          </el-table-column>
          <el-table-column label="字段Key" align="center" prop="FieldKey">
          </el-table-column>
          <el-table-column label="字段类型" align="center" prop="ColumnType">
          </el-table-column>
          <el-table-column label="枚举定义" align="center" prop="Enumeration">
            <template slot-scope="scope">
              <el-input
                v-model="scope.row.Enumeration"
                placeholder=""
                type="textarea"
                rows="2"
                resize="none"
              ></el-input>
            </template>
          </el-table-column>
          <el-table-column label="字段说明" align="center" prop="Describe">
            <template slot-scope="scope">
              <el-input
                v-model="scope.row.Describe"
                placeholder=""
                type="textarea"
                rows="2"
                resize="none"
              ></el-input>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="footer" v-loading="loading">
        <el-button @click="close">取消</el-button>
        <el-button type="primary" @click="handleSubmit">保存</el-button>
      </div>
    </el-drawer>
  </div>
</template>
<script>
import Token from '@/utils/cache/TokenCache.js'
export default {
  data() {
    return {
      title: '',
      loading: false,
      token: 'Bearer ' + Token.getToken(),
      RoleList: [],
      list: [],
      form: {
        TableKey: '',
        TableName: '',
        Describe: '',
        list: [],
      },
      rules: {
        // UserCode: [{ required: true, message: "请输入用户编号", trigger: "blur" }],
        // UserName: [{ required: true, message: "请输入用户名账号", trigger: "blur" }],
      },
      drawer: false,
    }
  },
  props: {},
  components: {},
  methods: {
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg' || file.type === 'image/png'
      const isLt2M = file.size / 1024 / 1024 < 20

      if (!isJPG) {
        this.$notify.error('上传图片只能是 JPG 或 PNG 格式!')
      }
      if (!isLt2M) {
        this.$notify.error('上传头像图片大小不能超过 20MB!')
      }
      return isJPG && isLt2M
    },
    handleAvatarSuccess(res) {
      console.log(res, 'res')
      if (res.status == 'done') {
        this.form.HeadImg = res.url

        console.log(this.form.HeadImg)
      } else {
        this.$notify.error(res.Msg)
      }
    },
    getRoleList() {
      this.$http
        .post('/Base_Manage/Base_Role/GetDataList', {
          SortField: 'CreateTime',
          SortType: 'Desc',
        })
        .then((resJson) => {
          if (resJson.Success) {
            this.RoleList = resJson.Data
          }
        })
    },
    handleSubmit() {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return this.$notify.error('请检查输入项')
        }
        this.loading = true
        this.$http
          .post('/Base/SystemTable/SaveData', this.form)
          .then((resJson) => {
            this.loading = false

            if (resJson.Success) {
              this.$notify.success('操作成功!')
              this.$emit('success')
              this.close()
            } else {
              this.$notify.error(resJson.Msg)
            }
          })
      })
    },
    openForm(title, row = {}) {
      this.drawer = true
      // this.getRoleList();

      this.form = {
        TableKey: '',
        TableName: '',
        Describe: '',
        list: [],
      }
      this.$nextTick(() => {
        this.$refs.form.resetFields()
      })
      this.title = title
      if (row.Id) {
        this.getInfo(row.Id)
      }
    },
    getInfo(id) {
      this.loading = true
      this.$http
        .post('/Base/SystemTable/GetTheData', { id: id })
        .then((resJson) => {
          this.loading = false
          if (resJson.Success) {
            this.form = resJson.Data
          } else {
            this.$notify.error(resJson.Msg)
          }
        })
    },
    close() {
      this.drawer = false
    },
    handleClose(done) {
      this.$confirm('确认关闭？')
        .then(() => {
          done()
        })
        .catch(() => {})
    },
  },
  mounted() {},
  created() {},
  computed: {},
  watch: {},
}
</script>
<style lang="scss" scoped>
::v-deep .el-drawer__header {
  margin: 0;
  padding: 20px;
}
.form-center {
  height: calc(100vh - 120px);
  padding: 20px;
}
.footer {
  height: 40px;
  line-height: 40px;
  text-align: right;
  padding: 0 20px;
}
::v-deep .avatar-uploader .el-upload {
  width: 100px;
  height: 100px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}

::v-deep .avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 65px;
  height: 60px;
  line-height: 60px;
  text-align: center;
}
</style>
